import React, { useState, useEffect } from 'react';
import { BiColorFill } from 'react-icons/bi';
import ColorPickerPopup from './ColorPickerPopup';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { useNavigate } from 'react-router-dom';

const Header = ({ Data, i18, OnLanguageChange, isLandingPage }) => {
  const [colorPickerVisible, setColorPickerVisible] = useState(false);
  const [language, setLanguage] = useLocalStorage('language', 'EN');
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const changeLanguage = () => {
    const newLanguage = language === 'EN' ? 'ES' : 'EN';
    setLanguage(newLanguage);
  };

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  const scrollToSection = (e, hash) => {
    e.preventDefault();
    setMenuOpen(false);
    const el = document.getElementById(hash);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    } else if (!isLandingPage) {
      navigate('/' + '#' + hash);
    } else {
      window.location.hash = hash;
    }
  };

  useEffect(() => {
    OnLanguageChange(language);
  }, [language]);

  useEffect(() => {
    if (!isLandingPage) {
      setIsScrolled(true);
      return;
    } else {
      let ticking = false;
      const handleScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            if (window.scrollY > 400) {
              setIsScrolled(true);
            } else {
              setIsScrolled(false);
            }
            ticking = false;
          });
          ticking = true;
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [isLandingPage]);

  return (
    <React.Fragment>
      <header className={menuOpen ? 'nav-open' : ''}>
        <div className="profile-page sidebar-collapse">
          <nav
            className={`navbar navbar-expand-lg fixed-top transition-navbar ${isScrolled
              ? 'bg-primary'
              : 'navbar-transparent bg-primary'
              }`}
          >
            <div className="container">
              <div className="navbar-translate">
                <a className="navbar-brand" href="/#" rel="tooltip">
                  {Data.about.name}
                </a>
                <div className="theme-picker-wrapper ml-auto pr-2 d-block d-lg-none">
                  <a
                    href="/#"
                    onClick={(e) => {
                      e.preventDefault();
                      setColorPickerVisible(true);
                    }}
                  >
                    {false && (
                      <button className="theme-picker">
                        <BiColorFill />
                      </button>
                    )}
                  </a>
                </div>
                <button
                  className={`navbar-toggler ${menuOpen ? 'toggled' : ''}`}
                  type="button"
                  onClick={toggleMenu}
                  aria-controls="navigation"
                  aria-expanded={menuOpen}
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-bar bar1"></span>
                  <span className="navbar-toggler-bar bar2"></span>
                  <span className="navbar-toggler-bar bar3"></span>
                </button>
              </div>
              <div
                className={`collapse navbar-collapse justify-content-end ${menuOpen ? 'show' : ''}`}
                id="navigation"
              >
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <a className="nav-link" href="/#about" onClick={(e) => scrollToSection(e, 'about')}>
                      {i18.LNK_HEADER_ABOUT}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/#skill" onClick={(e) => scrollToSection(e, 'skill')}>
                      {i18.LNK_HEADER_SKILLS}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/#projects" onClick={(e) => scrollToSection(e, 'projects')}>
                      {i18.LNK_HEADER_PROJECTS}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/#contact" onClick={(e) => scrollToSection(e, 'contact')}>
                      {i18.LNK_HEADER_CONTACT}
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/blog" onClick={(e) => {
                      e.preventDefault();
                      setMenuOpen(false);
                      navigate('/blog');
                    }}>
                      {i18.LNK_HEADER_BLOG}
                    </a>

                  </li>
                  <li className="nav-item">
                    <a
                      href="/#"
                      className="nav-link"
                      onClick={(e) => {
                        e.preventDefault();
                        changeLanguage();
                      }}
                    >
                      {language}
                    </a>
                  </li>

                  <li className="nav-item pl-lg-5 theme-picker-wrapper d-none d-lg-block">
                    <a
                      href="/#"
                      className="nav-link"
                      onClick={(e) => {
                        e.preventDefault();
                        setColorPickerVisible(true);
                      }}
                    >
                      {false && (
                        <button className="theme-picker">
                          <BiColorFill />
                        </button>
                      )}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </header>
      {colorPickerVisible && (
        <ColorPickerPopup
          visible={colorPickerVisible}
          handleCancel={() => {
            setColorPickerVisible(false);
          }}
        />
      )}
    </React.Fragment>
  );
};

export default Header;
